import React from 'react'
import classnames from 'classnames/bind'

import { RowDeprecated } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import { EditorView } from '@caudena/core/Editor'
import { ReactComponent as ApproveIcon } from '@caudena/core/assets/approve.svg'

import CaseActivityCard from './index'

import { FeedStatusChangedActivity } from '../../../../types/Case'

import styles from './index.scss'
import { SnakeToCamelCaseObject } from '@caudena/core/utilsTypes'

const cx = classnames.bind(styles)

interface CaseStageActivityCardProps {
  activity: SnakeToCamelCaseObject<FeedStatusChangedActivity>
  className?: string
}

const CaseStageActivityCard: React.FC<CaseStageActivityCardProps> = ({
  activity,
  className,
}) => {
  const status =
    activity.activity.statusTo === 'pending'
      ? 'review'
      : activity.activity.statusTo

  return (
    <CaseActivityCard
      className={className}
      icon={<ApproveIcon />}
      title="Status"
      main={
        <Typography variant="body3" color="grey2">
          <RowDeprecated gap={0.5}>
            {activity.user.name}
            <Typography color="grey2"> changed status to </Typography>
            <Typography transform="capitalize" variant="body3">
              {status}
            </Typography>
          </RowDeprecated>
        </Typography>
      }
      date={new Date(activity.insertedAt)}
    >
      {activity.activity.comment && (
        <div className={cx('Comment')}>
          <EditorView value={activity.activity.comment} />
        </div>
      )}
    </CaseActivityCard>
  )
}

export default CaseStageActivityCard
